export default __webpack_public_path__ + "static/media/02.e7655450.jpg";